<template>
  <div class="list-item van-hairline--bottom">
    <div class="top-content wh-flex-between">
      <div class="farm-work">
        {{ item.farmWork }}
      </div>
      <van-tag v-if="showLandName" plain class="land-name" round>
        {{ item.landName }}
      </van-tag>
    </div>
    <div class="wh-flex-between bottom-content">
      <div class="time-range wh-flex-start">
        <div class="begin-time">
          {{ formatTime(item.beginTime, 'YYYY-MM-DD') }}
        </div>
        <div class="divide">
          ~
        </div>
        <div class="end-time">
          {{ formatTime(item.endTime, 'YYYY-MM-DD') }}
        </div>
      </div>
      <van-tag type="success" size="large" class="operator">
        {{ item.operator }}
      </van-tag>
    </div>
  </div>
</template>

<script>
import { formatTime } from '@/utils/convert/convertTime'
export default {
  name: 'FarmWorkRecordItem',
  props: {
    item: {
      type: Object,
      default() {
        return {}
      }
    },
    showLandName: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    formatTime
  }
}
</script>

<style lang='less' scoped>
.list-item {
  padding: 12px;
  background: #fff;
  .farm-work {
    font-size: 18px;
  }
  .land-name {
    padding: 0 8px;
  }
  .time-range {
    color: @primary-color;
    margin-top: 6px;
    display: flex;
    font-size: 14px;
  }
  .operator {
    margin-top: 4px;
  }
}
</style>
